import { styled, Theme } from '../../../../base';

export const Container = styled('div')(({ theme }: { theme: Theme }) => ({
    padding: theme.spacing(0, 1, 1, 1),
    height: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    borderRight:
        theme.direction === 'rtl'
            ? `1px solid ${theme.palette.divider}`
            : 'none',
    borderLeft:
        theme.direction === 'rtl'
            ? 'none'
            : `1px solid ${theme.palette.divider}`,
}));

export const Header = styled('div')(({ theme }: { theme: Theme }) => ({
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    paddingInlineStart: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.divider}`,
    zIndex: 1,
}));

export const HeaderActions = styled('div')(({ theme }: { theme: Theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
}));

export const VersionSelectorContainer = styled('div')({
    minWidth: 120,
});
